import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { TbSquareRoundedPlusFilled } from 'react-icons/tb';
import ThreadsList from '../components/ThreadsList';
import CategoryList from '../components/CategoryList';
import OwnProfile from '../components/OwnProfile';
import { asyncPopulateUsersAndThreads } from '../states/shared/action';
import { asyncReceiveCategories } from '../states/categories/action';

function HomePage() {
  const {
    threads = [],
    users = [],
    categories,
    authUser,
    threadVotes,
  } = useSelector((states) => states);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      dispatch(asyncPopulateUsersAndThreads());
      dispatch(asyncReceiveCategories());
    };

    fetchData();
  }, [dispatch]);

  useEffect(() => {
    const updateThread = async () => {
      dispatch(asyncPopulateUsersAndThreads());
    };

    updateThread();
  }, [threadVotes, dispatch]);

  const onCreateThread = () => {
    navigate('/new');
  };

  if (
    threads.length === 0 || !users || !categories || !authUser) {
    return null;
  }

  const threadList = threads.map((thread) => ({
    ...thread,
    user: users.find((user) => user.id === thread.ownerId),
    authUser,
  }));

  return (
    <section className="home-page">
      {categories && <CategoryList categories={categories} />}
      <div className="home-page__component">
        <ThreadsList threads={threadList} />
      </div>
      <OwnProfile authUser={authUser} />
      <button type="button" onClick={onCreateThread} aria-label="Create Thread">
        <TbSquareRoundedPlusFilled />
      </button>
    </section>
  );
}

export default HomePage;
